/**
 * @returns the base url like http://localhost:8080/qisserver
 */
export function getBaseUrl(): string {
    let url = window.location.href;
    let ixd = url.indexOf('/a/');
    let baseUrl =  url.substring(0, ixd);
    //expected url like http://localhost:8080/qisserver
    return baseUrl;
}

/**
 * Entfernt einen URL-Parameter aus der gegebenen url.
 * @param url die zu bearbeitende URL
 * @param param Der zu entfernende URL-Parameter, üblicherweise in der Form <key>=<value>
 * @return url ohne den param falls ursprünglich vorhanden, ansonsten die originale url
 */
export function removeUrlParam(url: string, param: string): string {
    if (url.indexOf('&' + param) >= 0) {
        // param ist nicht der erste URL-Parameter.
        return url.replace('&' + param, '');
    }
    if (url.indexOf('?' + param + '&') >= 0) {
        // param ist der erste URL-Parameter, aber es gibt noch weitere. Das ? muss erhalten bleiben.
        return url.replace(param + '&', '');
    }
    if (url.indexOf('?' + param) >= 0) {
        // param ist der einzige URL-Parameter. Das ? kann dann ebenfalls weg.
        return url.replace('?' + param, '');
    }
    console.log('HisUrlUtils: url ' + url + ' does not contain url parameter ' + param + '. The url is returned unchanged.');
    return url;
}
